import React from 'react';
import { Radio } from 'antd';
import classname from 'classnames';

function MrphRadio({
  datatestid,
  value,
  type,
  children,
  className = 'bordered',
  error,
  black,
  name,
  ...props
}) {
  return (
    <Radio
      value={value}
      data-testid={datatestid ? `${datatestid}` : null}
      aria-label={name}
      className={classname(
        className,
        {
          error: error,
          black: black,
        },
        'brand-radio',
      )}
      {...props}
    >
      {children}
    </Radio>
  );
}

export { MrphRadio as Radio };
